import { SessionState } from "../session.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const setFirstSessionReducer = (
  state: SessionState,
  action: PayloadAction<boolean>,
) => {
  state.isFirstSession = action.payload;
};
